<template>
    <tg-layout>
        <template slot="header">
            <el-row type="flex" justify="start" align="left">
                <tg-search-tool
                    @on-submit="handleSearch"
                    showClearBtn
                    @on-clear="handleClear"
                    :clearDisabled="!isSearch"
                >
                    <el-input
                        :placeholder="
                            $t('component.form.input.placeholder.agent')
                        "
                        v-model="target_name"
                        class="tg-input"
                        size="small"
                        style="width: 220px"
                        clearable
                    ></el-input>
                </tg-search-tool>
            </el-row>
        </template>
        <template v-if="$user.group > 40" slot="header">
            <tg-list-card-group
                :lists="list"
                @on-click="searchTargetUser"
                :disabled="isSearch"
                >{{ list }}</tg-list-card-group
            >
        </template>
        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            showPagination
            :summary-method="parseSummary"
            showSummary
            @on-loaded="handleLoaded"
            @sort-change="handleSortChange"
            @cell-click="handleCellClick"
            :cell-class-name="parseCellClass"
        >
            <template slot="header.userfullname" slot-scope="scope">
                <template v-if="group">{{ $t(usernameLang) }}</template>
                <template v-else>{{
                    $t("column." + scope.column.langKey)
                }}</template>
            </template>
            <template slot="userfullname" slot-scope="scope">
                <tg-user-full-name
                    :row="scope.row"
                    :column="scope.column"
                ></tg-user-full-name>
            </template>
            <template slot="total" slot-scope="scope">
                <span :class="{ 'as-link': scope.value != '0' }">{{
                    scope.formated
                }}</span>
            </template>
            <template slot="success" slot-scope="scope">
                <span>{{ scope.formated }}</span>
            </template>
            <template slot="fail" slot-scope="scope">
                <span>{{ scope.formated }}</span>
            </template>
        </tg-table>
        <!-- <tg-loading v-if="showLoading"></tg-loading> -->
    </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgListCardGroup from "@/components/card/TgListCardGroup";
// import TgLoading from "@/components/TgLoading";
import { summary } from "@/utils/table";

import apis from "@/apis";
import str from "@/utils/str";

const api = apis.activity.agent;

export default {
    components: {
        TgLayout,
        TgTable,
        TgSearchTool,
        TgUserFullName,
        TgListCardGroup,
        // TgLoading,
    },
    data() {
        return {
            isSearch: false,
            proxy: api.getData,
            columns: [],
            amountData: {},
            group: "",
            upperGroup: "",
            counter: 0,
            list: [],
            // showLoading: false,
            target_name: "",
            searchData: {
                target_name: "", //查詢的通路商
                activity_id: "", //查詢的活動id
                col_name: "", //欲排序序之欄位
                asc: 1,
            },
        };
    },
    props: {
        hasUser: Boolean,
    },
    created() {
        if (!this.$route.params.activity_id) {
            this.$router.push({ name: "activity.record.board.index" });
        }
        this.$store.commit("breadcrumb/clear");

        this.searchData.activity_id = this.$route.params.activity_id;
        this.searchData.target_name = this.$user.id;

        api.getColumns().then((response) => {
            let columns = response.data.columns;
            columns[0].renderHeader = this.renderHeader;
            this.columns = columns;
            this.$refs.table.init(this.searchData);
        });
    },
    computed: {
        usernameLang() {
            if (!this.group) {
                return "column.userfullname";
            }
            return "column.l" + this.group + "_account";
        },
    },
    methods: {
        renderHeader(h) {
            return h("span", this.$t(this.usernameLang));
        },
        parseCellClass({ column }) {
            if (column.columnKey == "total_of_apply") {
                return "clickable";
            }
        },
        handleSearch() {
            // this.showLoading = true;
            this.search = true;
            this.isSearch = true;
            this.searchData.target_name = this.target_name;
            if (this.searchData.target_name === "") {
                this.searchData.target_name = this.$user.id;
            }
            this.$nextTick(() => {
                this.$refs.table.search({ ...this.searchData });
            });
        },
        handleClear() {
            this.isSearch = false;
            this.target_name = "";
            this.searchData.target_name = this.$user.id;
            this.$nextTick(() => {
                this.$refs.table.search({ ...this.searchData });
            });
        },
        handleSortChange({ prop, order }) {
            let searchData = { ...this.searchData };
            (searchData.col_name = prop),
                (searchData.asc = order == "ascending" ? 1 : 0);
            this.$refs.table.search(searchData);
        },
        handleCellClick(row, col) {
            if (col.columnKey == "total_of_apply") {
                let routeName = "activity.record.detail";
                this.$router.push({
                    name: routeName,
                    params: {
                        activity_id: this.$route.params.activity_id,
                        target_name: row.username,
                    },
                });
            }
        },
        handleLoaded(response) {
            if(response.retcode == 0){
                this.group = response.list.group;
                if (response.list.group == "20") {
                    this.$router.push({
                        name: "activity.record.detail",
                        params: {
                            activity_id: this.$route.params.activity_id,
                            target_name: response.list.agent_name,
                        },
                    });
                } else if (response.list.group == "10") {
                    this.$router.push({
                        name: "activity.record.detail",
                        params: {
                            activity_id: this.$route.params.activity_id,
                            target_name: this.$user.id,
                            search_name: this.target_name,
                        },
                    });
                }
                this.upperGroup = response.list.upperGroup;
                let options = [70, 60, 40];
                let index = options.findIndex((x) => x == this.group);
                let array = JSON.parse(JSON.stringify(this.list));
                if (index >= 0) {
                    if (this.group == this.$user.group) {
                        this.counter = index;
                        array = [response.list];
                    } else {
                        array = array.slice(0, index - this.counter);
                        array[index - this.counter] = response.list;
                    }
                    if (!this.isSearch) {
                        this.list = array;
                    }
                }
                this.$store.commit("breadcrumb/clear");
                this.$store.commit("breadcrumb/add", {
                    id: "activity.record.agent.activity_" + response.activity_name,
                    name: "activity.record.agent.activity_name",
                    query: {
                        ...this.$route.query,
                    },
                    params: this.$route.params,
                    meta: {
                        title: response.activity_name,
                        disable: true,
                    },
                });

                let target_name = "agent_name";

                if (this.search) {
                    target_name = response.list.agent_name;
                } else {
                    target_name = this.$user.id;
                }

                let title = "";
                if (this.upperGroup != null && this.upperGroup != "undefind") {
                    title = str.format(
                        "{0} ({1})",
                        this.$t("column.l" + this.upperGroup),
                        target_name
                    );
                } else {
                    title = this.$t("column.not_found_agent");
                }

                this.$store.commit("breadcrumb/add", {
                    id: "activity.record.agent.user_" + target_name,
                    name: "activity.record.agent.user",
                    query: {
                        ...this.$route.query,
                    },
                    params: {
                        target_name: target_name,
                    },
                    meta: {
                        title: title,
                        disable: true,
                    },
                });

                if (this.isSearch) {
                    this.searchData.target_name = this.target_name;
                }
            }
        },
        searchTargetUser(item) {
            this.search = true;
            this.searchData.target_name = item;
            this.$nextTick(() => {
                this.$refs.table.search({ ...this.searchData });
            });
        },
        togglePage(hasUser, route) {
            if (hasUser) {
                this.$refs.table.search({
                    ...this.searchData,
                    target_name: route.params.username,
                });
            } else {
                this.$store.commit("breadcrumb/clear");
                this.$refs.table.search(this.searchData);
            }
        },
        /**
         * 解析合計資訊
         */
        parseSummary({ data }) {
            return summary(
                this.columns,
                data,
                this.$t("component.table.summary"),
                0
            );
        },
    },
};
</script>
